<div #headerContainer class="header-container d-flex">
  <div class="sticky-box">
    <div [style.width.px]="resourcesColumnWidthPx$ | async">
      <div class="header" [class.sticky-shadow]="stickyHasShadow"></div>
    </div>
  </div>

  @if (
    {
      frameLength: frameLength$ | async,
      holidayRegions: publicHolidaysRegion$ | async,
    };
    as data
  ) {
    <div>
      <div [style.width.px]="data.frameLength">
        <div
          id="right-header"
          class="header"
          [class.sticky-shadow]="stickyHasShadow"
        >
          <div class="header-top">
            <div class="position-relative w-100 h-100">
              @for (
                day of daysRange$ | async;
                track day;
                let i = $index;
                let c = $count
              ) {
                @if (
                  {
                    publicHolidayName:
                      day | getPublicHolidayName: data.holidayRegions || [],
                    isWeekend: day | dfnsIsWeekend,
                    isToday: day | dfnsIsToday,
                  };
                  as data
                ) {
                  <div
                    class="day-container"
                    [ngClass]="{
                      'day-container--weekend-or-holiday':
                        data.isWeekend || !!data.publicHolidayName,
                      'highlight-top-border': data.isToday,
                    }"
                    [style.left]="i | ganttDayLeftPipe: c"
                    [style.right]="i | ganttDayRightPipe: c"
                  >
                    <div
                      class="d-flex"
                      [class.today]="data.isToday"
                      nz-tooltip
                      [nzTooltipTitle]="data.publicHolidayName || ''"
                    >
                      <small>{{ day | date }}</small>
                      <small class="mx-1">
                        ({{ day | dfnsFormatPure: 'iiiiii' }})
                      </small>
                      @if (!!data.publicHolidayName) {
                        &nbsp; &nbsp;
                        <nz-tag [nzColor]="'magenta'">
                          {{ 'general.holiday' | translate }}</nz-tag
                        >
                      }
                    </div>
                    <div class="hours-container">
                      @for (hour of hoursRange$ | async; track hour) {
                        <span>
                          {{ hour }}
                        </span>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</div>
